import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket/store'
import type { IResponseConversationUnread } from 'entities/Conversation/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventConversationUnreadLog = () => {
  const { websocket, dataLogStore } = useEntitiesContext()
  const handle = (data: IResponseConversationUnread) => {
    const { conversation, trace_payload } = data

    dataLogStore.setItem({
      logLevel: 'info',
      message: 'EventConversationUnread',
      details: {
        conversationId: conversation.id,
        totalUnread: conversation.unread_count,
        conversationUnread: Boolean(conversation.unread_count),
        lastReadAt: conversation.last_read_at,
        lastMessageAt: conversation.last_message_at,
        traceId: trace_payload?.trace_id,
      },
    })
  }

  useEffect(() => websocket.on(WebsocketEvent.ConversationUnread, handle), [])
}
